import TierStoresMock from '@/services/MockData/ClubPlus/TierStoresData.json'
import {HTTP_METHODS} from '@/utils/constants/httpMethods'

export const TIER_CONFIG = {
  TIERS: {
    endPoint: 'tier-setup',
    method: HTTP_METHODS.GET,
  },
  TIER_STORES: (tierID, queryParams) => ({
    endpoint: `tier/${tierID}/stores?${queryParams}`,
    mockData: TierStoresMock,
  }),
}
